import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './GamesPage.css';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import BingoCard from './BingoCard';
import winSound from '../Assets/win.mp3';
import loseSound from '../Assets/lose.mp3';
import LoadingOverlay from './LoadingOverlay';
import localforage from 'localforage';
import CryptoJS from 'crypto-js';
import Confetti from 'react-confetti';
import api from '../api';
import { Dialog, DialogContent, DialogFooter } from '../Components/ui/dialog';
import { useAuthValidation } from '../hooks/useAuthValidation';
import { Button } from '../Components/ui/button';
import { FaCrown } from 'react-icons/fa';
import { FaVolumeUp, FaVolumeDown, FaVolumeMute, FaChevronDown, FaChevronUp, FaCompress, FaExpand } from 'react-icons/fa';
import shuffleSound from '../Assets/Audio/shufflen.m4a';
import { verifyWin } from '../Utils/winVerification';
import { toast, Toaster } from 'react-hot-toast';


const shuffleAnimationStyles = `
  @keyframes shuffle {
    0% {
      transform: translateY(0) rotate(0deg) scale(1);
    }
    25% {
      transform: translateY(-15px) rotate(-15deg) scale(1.1);
    }
    75% {
      transform: translateY(15px) rotate(15deg) scale(1.1);
    }
    100% {
      transform: translateY(0) rotate(0deg) scale(1);
    }
  }

  @keyframes swap {
    0% {
      transform: translate(0, 0) rotate(0deg);
    }
    25% {
      transform: translate(var(--random-x1), var(--random-y1)) rotate(180deg);
    }
    75% {
      transform: translate(var(--random-x2), var(--random-y2)) rotate(-180deg);
    }
    100% {
      transform: translate(0, 0) rotate(0deg);
    }
  }

  @keyframes inner-rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .animate-shuffle {
    animation: shuffle 0.8s ease-in-out infinite;
  }

  .animate-swap {
    animation: swap 1s ease-in-out infinite;
  }

  .animate-inner-rotate {
    animation: inner-rotate 1s linear infinite;
  }
`;

const GamePage = () => {
  const location = useLocation();
  const { audioLanguage, commissionRate } = location.state || {};
  const { payoutToWinner, gameType, houseCards, winningCalls, winningCard, houseWin, baseAmount, totalBonusAmount,} = location.state || {};
  const gameId = location.state?.gameId;
  const calledNumbers = location.state?.calledNumbers;
  const multiplier = location.state?.multiplier;
  const playingCards = location.state?.playingCards;
  const callSpeed = location.state?.callSpeed;
  const payoutAmount = location.state?.payoutToWinner
  const [totalCalls, setTotalCalls] = useState(0);
  const [checkedNumber, setCheckedNumber] = useState('');
  const [lastCalledNumber, setLastCalledNumber] = useState('');
  const [intervalId, setIntervalId] = useState(null);
  const [winnerCard, setWinnerCard] = useState(null);
  const [isPaused, setIsPaused] = useState(true);
  const audioRef = useRef(null);
  const [showWinnerModal, setShowWinnerModal] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [slideshowTables, setSlideshowTables] = useState([]);
  const [countdown, setCountdown] = useState(callSpeed / 1000);
  const [remainingCountdown, setRemainingCountdown] = useState(callSpeed / 1000);
  const [showCardDisplay, setShowCardDisplay] = useState(false);
  const [winner, setWinner] = useState(false);
  const [calledIndex, setCalledIndex] = useState(-1);
  const [calledNumbersArray, setCalledNumbersArray] = useState([]);
  const winAudioRef = useRef(null);
  const loseAudioRef = useRef(null);
  const [audioFilesLoaded, setAudioFilesLoaded] = useState(false);
  const [isChecking, setIsChecking] = useState(false);
  const [showHouseWinModal, setShowHouseWinModal] = useState(false);
  const [gameEnded, setGameEnded] = useState(false);
  const [houseWinningCard, setHouseWinningCard] = useState(null);
  const [winningAmount, setWinningAmount] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [checkedCards, setCheckedCards] = useState([]);
  const [checkedResults, setCheckedResults] = useState([]);
  const [numberOfWinners, setNumberOfWinners] = useState(0);
  const [volume, setVolume] = useState(0.8);
  const [gameVersion, setGameVersion] = useState(localStorage.getItem('gameVersion') || 'v1');
  const [winningNumbers, setWinningNumbers] = useState()
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [shuffleSoundLoaded, setShuffleSoundLoaded] = useState(false);
  const [lockedCards, setLockedCards] = useState([]);
  const [isJackpotGame, setIsJackpotGame] = useState(false);
  const [jackpotPool, setJackpotPool] = useState(0);
  
  const [winningPattern, setWinningPattern] = useState(() => {
    try {
      const stored = localStorage.getItem('winningPattern');
      return stored ? JSON.parse(stored) : ['any'];
    } catch (error) {
      return ['any'];
    }
  });

  const shuffleAudioRef = useRef(null);
  const [isShuffling, setIsShuffling] = useState(false);
  
  useEffect(() => {
    const loadShuffleSound = async () => {
      try {
        // Check if shuffle sound is already cached
        const cachedShuffleSound = await localforage.getItem('shuffle-sound');
        
        if (cachedShuffleSound) {
          // Use cached sound
          const audioBlob = new Blob([cachedShuffleSound], { type: 'audio/m4a' });
          const audioUrl = URL.createObjectURL(audioBlob);
          shuffleAudioRef.current = new Audio(audioUrl);
          setShuffleSoundLoaded(true);
        } else {
          // Fetch and cache the sound
          const response = await fetch(shuffleSound);
          const arrayBuffer = await response.arrayBuffer();
          
          // Store in localforage
          await localforage.setItem('shuffle-sound', arrayBuffer);
          
          // Create audio from the fetched data
          const audioBlob = new Blob([arrayBuffer], { type: 'audio/m4a' });
          const audioUrl = URL.createObjectURL(audioBlob);
          shuffleAudioRef.current = new Audio(audioUrl);
          setShuffleSoundLoaded(true);
        }
      } catch (error) {
        console.error('Error loading shuffle sound:', error);
        // Fallback to direct loading if caching fails
        shuffleAudioRef.current = new Audio(shuffleSound);
        setShuffleSoundLoaded(true);
      }
    };
    
    loadShuffleSound();
    
    // Cleanup function
    return () => {
      if (shuffleAudioRef.current) {
        URL.revokeObjectURL(shuffleAudioRef.current.src);
      }
    };
  }, []);

  const handleShuffle = () => {
    if (isPaused && !isShuffling && shuffleSoundLoaded) {
      setIsShuffling(true);
      if (shuffleAudioRef.current) {
        shuffleAudioRef.current.currentTime = 0;
        shuffleAudioRef.current.play()
          .catch(error => console.error('Error playing shuffle sound:', error));
      }
      
      setTimeout(() => {
        setIsShuffling(false);
      }, 12000); // 12 seconds of shuffling animation
    }
  };

  const getApiUrl = () => {
    const hashedApiVersion = localStorage.getItem('apiVersion');
    if (hashedApiVersion) {
      const version2Hash = CryptoJS.SHA256('2').toString();
      if (hashedApiVersion === version2Hash) {
        return 'https://phoenix-bingo-2.onrender.com/api';
      }
    }
    return process.env.REACT_APP_API;
  };

  const GameVersionToggle = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
      <div className="max-h-8 version-toggle-container mb-0 flex justify-between bg-gray-800">
        <div className="bg-gray-800 p-1 rounded-lg inline-flex shadow-md">
        <button 
          className="md:hidden w-full text-white p-1 flex justify-between items-center"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          Version {gameVersion.slice(1)} 
          <FaChevronDown className={`transition-transform ${isExpanded ? 'rotate-180' : ''} ml-2`} />
        </button>
        <div className={`${isExpanded ? 'block' : 'hidden'} mx-4 md:block md:inline-flex gap-2`}>
          {['v1', 'v2', 'v3'].map((version) => (
            <button
            key={version}
            className={`
              max-h-5 px-2 py-0.25 rounded-sm text-sm transition-all duration-200 max-h-10 min-h-1
              ${gameVersion === version
                ? 'bg-gradient-to-r from-amber-400 to-yellow-500 text-black shadow-sm'
                : 'bg-gray-400 text-black hover:text-gray-400'
              }
            `}
            onClick={() => {
              setGameVersion(version);
              localStorage.setItem('gameVersion', version);
              setIsExpanded(false);
            }}
          >
            Version {version.slice(1)}
          </button>
          ))}
          </div>
        </div>
        <FullScreenButton />
        {volumeControls}
        <div className="text-warning text-4xl p-0">ወኪልዎን ያነጋግሩ</div>
        <div className="phoenix-logo mr-4 ">
          <div className='flex space-x-2'> <FaCrown className="icon"/> <div className="phoenix-text">Fast <span className="bingo-text">BINGO</span></div></div>
        </div>
      </div>
    );
  };

  const FullScreenButton = () => {
    const [isFullScreen, setIsFullScreen] = useState(false);
  
    const toggleFullScreen = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().then(() => {
          setIsFullScreen(true);
        });
      } else {
        document.exitFullscreen().then(() => {
          setIsFullScreen(false);
        });
      }
    };
  
    return (
      <button
        onClick={toggleFullScreen}
        className="min-h-5 mt-0 pt-0 max-h-5 text-white hover:text-amber-400 transition-colors duration-200"
        title={isFullScreen ? "Exit fullscreen" : "Enter fullscreen"}
      >
        {isFullScreen ? (
          <FaCompress size={20} />
        ) : (
          <FaExpand size={20} />
        )}
      </button>
    );
  };

  useAuthValidation();

  const API = getApiUrl();

  useEffect(() => {
    const checkAudioFiles = async () => {
      try {
        // Check if first and last audio files exist as a quick verification
        const firstKey = `audio-${audioLanguage}-B1`;
        const lastKey = `audio-${audioLanguage}-O75`;
        const [first, last] = await Promise.all([
          localforage.getItem(firstKey),
          localforage.getItem(lastKey)
        ]);

        // If both exist, assume all files are cached
        if (first && last) {
          setAudioFilesLoaded(true);
          return;
        }

        // If not cached, proceed with download
        const audioPromises = [];
        const totalNumbers = 75;

        for (let i = 1; i <= totalNumbers; i++) {
          const letter = i <= 15 ? 'B' : 
                        i <= 30 ? 'I' : 
                        i <= 45 ? 'N' : 
                        i <= 60 ? 'G' : 'O';
          
          const number = letter + i;
          const audioKey = `audio-${audioLanguage}-${number}`;
          
          let audioFolder;
          switch(audioLanguage) {
            case 'male1':
              audioFolder = 'male1';
              break;
            case 'tig':
              audioFolder = 'tig';
              break;
            default:
              audioFolder = audioLanguage;
          }
          
          const audioSrc = require(`../Assets/Audio/${audioFolder}/${number}.aac`);
          
          const downloadPromise = fetch(audioSrc)
            .then(response => response.arrayBuffer())
            .then(arrayBuffer => localforage.setItem(audioKey, arrayBuffer))
            .catch(error => console.error(`Error loading audio ${number}:`, error));
          
          audioPromises.push(downloadPromise);
        }

        // Download files in parallel with a limit of 15 concurrent downloads
        const chunkSize = 15;
        for (let i = 0; i < audioPromises.length; i += chunkSize) {
          const chunk = audioPromises.slice(i, i + chunkSize);
          await Promise.all(chunk);
        }

        setAudioFilesLoaded(true);
      } catch (error) {
        console.error('Error checking/loading audio files:', error);
      }
    };
    
    checkAudioFiles();
  }, [audioLanguage]);

  useEffect(() => {
    let interval;
    let countdownInterval;
  
    const startCallingNumbers = () => {
      interval = setInterval(() => {
        if (!isPaused && audioFilesLoaded) {
          setCalledIndex((prevIndex) => {
            const newIndex = prevIndex + 1;
            if (newIndex < calledNumbers.length) {
              const newLastCalledNumber = calledNumbers[newIndex];
              setLastCalledNumber(newLastCalledNumber);
              setCalledNumbersArray(calledNumbers.slice(0, newIndex + 1));
              
              localforage.getItem(`audio-${audioLanguage}-${newLastCalledNumber}`).then((arrayBuffer) => {
                const audioBlob = new Blob([arrayBuffer], { type: 'audio/aac' });
                const audioUrl = URL.createObjectURL(audioBlob);
                audioRef.current.src = audioUrl;
                audioRef.current.load();
                audioRef.current.addEventListener('canplaythrough', () => {
                  audioRef.current.play();
                });
              });
  
              return newIndex;
            }
            return prevIndex;
          });
        }
      }, callSpeed);
    };
  
    const startCountdown = () => {
      let remainingTime = Math.floor(callSpeed / 1000);

      setCountdown(remainingTime);
  
      countdownInterval = setInterval(() => {
        setCountdown((prevCountdown) => {
          const newCountdown = prevCountdown - 1;
          if (newCountdown <= 0) {
            clearInterval(countdownInterval);
          }
          return newCountdown;
        });
      }, 800);
    };
  
    clearInterval(interval);
    clearInterval(countdownInterval);
  
    if (!isPaused && calledIndex < calledNumbers.length - 1) {
      startCallingNumbers();
      startCountdown();
    }
  
    return () => {
      clearInterval(interval);
      clearInterval(countdownInterval);
    };
  }, [callSpeed, calledIndex, audioLanguage, calledNumbers, isPaused]);
  
  useEffect(() => {
    if (gameType === 'house' && houseWin && calledIndex === winningCalls - 1  && winningCard && !gameEnded) {
      setGameEnded(true);
      setHouseWinningCard(winningCard);
      setShowHouseWinModal(true);
      winAudioRef.current.play();
    }
  }, [calledIndex, winningCalls, gameType, winningCard, gameEnded]);

  const handleCloseHouseWinModal = () => {
    setShowHouseWinModal(false);
    navigate('/dashboard');
  }; 

  const volumeSliderStyles = `
  .volume-slider-container {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border-radius: 4px;
  }

  .volume-slider {
    width: 75px;
    height: 1px;
    outline: none;
    opacity: 0.7;
    transition: opacity .2s;
  }

  .volume-slider::-webkit-slider-runnable-track {
    width: 100%;
    height: 2px;
    border-radius: 1px;
  }

  .volume-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #00ff9d;
    cursor: pointer;
    margin-top: -8px; /* Centers the thumb on the track */
  }

  .volume-slider::-moz-range-track {
    width: 100%;
    height: 2px;
    background: #4B5563;
    border-radius: 1px;
  }

  .volume-slider::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    cursor: pointer;
  }

  .volume-icon {
    color: #00ff9d;
  }
  `;

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (audioRef.current) audioRef.current.volume = newVolume;
    if (winAudioRef.current) winAudioRef.current.volume = newVolume;
    if (loseAudioRef.current) loseAudioRef.current.volume = newVolume;
  };

  const volumeControls = (
    <div className="volume-slider-container">
      <FaVolumeUp size={20} className="volume-icon" />
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={handleVolumeChange}
        className="volume-slider"
        style={{
          background: `linear-gradient(to right, #00ff9d ${volume * 100}%, #4B5563 ${volume * 100}%)`,
        }}
      />
      <style>{volumeSliderStyles}</style>
    </div>
  );

  const fetchWinningCardDetails = async (cardNumber) => {
    try {
      const response = await api.get(`${API}/card/${cardNumber}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      return response;
    } catch (error) {
      console.error('Error fetching winning card details:', error);
      return null;
    }
  };

  const handleCheckNumber = async () => {
    try {
      setIsChecking(true);
      if (gameType === 'multiplierBingo') {
        const isValidCard = playingCards.some(card => card.paletteNumber === checkedNumber);
        if (!localStorage.selectedNumbers.includes(checkedNumber)) {
          toast.error('Card is not in the list of players. Please check the card number and try again.');
          setIsChecking(false);
          return;
        }
        
        // Check if card is locked
        if (lockedCards.includes(checkedNumber)) {
          toast.error('This card has been locked.');
          setIsChecking(false);
          return;
        }
      } else {
        if (checkedCards.includes(checkedNumber)) {
          toast.error('This card has already been checked');
          setIsChecking(false);
          return;
        }
        
        // Check if card is locked
        if (lockedCards.includes(checkedNumber)) {
          toast.error('This card has been locked.');
          setIsChecking(false);
          return;
        }
        
        if (!playingCards.includes(checkedNumber)) {
          toast.error('Card is not in the list of players. Please check the card number and try again.');
          setIsChecking(false);
          return;
        }
      }

      const card = playingCards.find(card => 
        gameType === 'multiplierBingo' 
          ? card.paletteNumber === checkedNumber
          : card === checkedNumber
      );
  
      if (!card) {
        toast.error('Card not found');
        setIsChecking(false);
        return;
      }

      let cardData = null;

      try {
        // First try to get card from localforage
        const storedCards = await localforage.getItem('bingoCards');
        if (storedCards) {
          const paletteNumber = parseInt(checkedNumber, 10);
          cardData = storedCards.find(c => c.paletteNumber === paletteNumber);
        }
      } catch (error) {
        console.error('Error retrieving card data from localStorage:', error);
      }

      // If not found in localforage, try to fetch from API
      if (!cardData) {
        try {
          const cardDetails = await fetchWinningCardDetails(checkedNumber);
          if (cardDetails) {
            cardData = cardDetails;
          } else {
            toast.error('Could not fetch card details from server');
            setIsChecking(false);
            return;
          }
        } catch (error) {
          console.error('Error fetching card details from API:', error);
          toast.error('Failed to retrieve card details. Please try again.');
          setIsChecking(false);
          return;
        }
      }
      
      // If we still don't have card data, show error and return
      if (!cardData) {
        toast.error('Could not retrieve card data');
        setIsChecking(false);
        return;
      }
      
      // Extract all numbers from the card
      const cardNumbers = [];
      
      // Extract numbers from each column (B, I, N, G, O)
      ['B', 'I', 'N', 'G', 'O'].forEach(letter => {
        if (cardData.numbers && cardData.numbers[letter]) {
          cardData.numbers[letter].forEach(num => {
            if (num !== 'FREE') {
              cardNumbers.push(`${letter}${num}`);
            }
          });
        }
      });

      // Filter called numbers to only include those on this card
      const cardCalledNumbers = calledNumbersArray.filter(num => cardNumbers.includes(num));
      
      // Set the winning numbers to only those that are on the card and have been called
      setWinningNumbers(cardCalledNumbers);

      const isWinner = await verifyWin(card, calledNumbersArray, winningPattern);

      // Update UI based on verification result
      setCheckedCards(prev => [...prev, checkedNumber]);
      setCheckedResults(prev => [...prev, isWinner]);
      setShowCardDisplay(true);
      setShowWinnerModal(true);

      if (isWinner) {
        setNumberOfWinners(prev => prev + 1);
        
        if (gameType === 'multiplierBingo') {
          const storedBettingAmounts = JSON.parse(localStorage.getItem('multiplierBettingAmounts') || '{}');
          const betAmount = storedBettingAmounts[checkedNumber] || localStorage.getItem('bettingAmount');
          const payoutToWinner = betAmount * localStorage.getItem('selectedNumbers').length;
          setWinningAmount(payoutToWinner);
        }

        winAudioRef.current.play();
        if (window.location.href.includes('phoenixbingo') || window.location.href.includes('local')) {
          setShowConfetti(true);
        }
      } else {
        loseAudioRef.current.play();
      }

      setCheckedNumber('');

      if (isWinner) {
        const response = await api.post(`${API}/game/isWinner/${gameId}/${checkedNumber}`, {
          calledNumbers: calledNumbersArray
        });
      }
    } catch (error) {
      console.error('Error checking winner:', error);
      toast.error('Error occurred while checking the winner card.');
    } finally {
      setIsChecking(false);
    }
  };
  const handleLockCard = () => {
    // Get the last checked card
    const lastCheckedCard = checkedCards[checkedCards.length - 1];
    
    if (!lastCheckedCard) {
      toast.error('No card has been checked yet');
      return;
    }
    
    if (lockedCards.includes(lastCheckedCard)) {
      toast.error('This card is already locked');
      return;
    }
    
    setLockedCards(prev => [...prev, lastCheckedCard]);
    toast.success(`Card ${lastCheckedCard} has been locked and will not be checkable again`);
  };

  const generateRows = (letter, start) => {
    const getRandomPosition = () => {
      const x = Math.random() * 100 - 50;
      const y = Math.random() * 100 - 50;
      return { x, y };
    };

    return (
      <div className="row p-0" style={{maxHeight: 60}}>
        <div className={`col bg-white text-primary text-center m-1 pb-1 px-0 ${isShuffling ? 'animate-shuffle' : ''}`} 
          style={{fontSize: 38, maxHeight: 48, maxWidth: 45}}
        >
          <span className={isShuffling ? 'animate-inner-rotate inline-block' : ''}>
            {letter}
          </span>
        </div>
        {[...Array(15)].map((_, i) => {
          const number = start + i;
          const isCalled = calledNumbersArray.includes(letter + number);
          const pos1 = getRandomPosition();
          const pos2 = getRandomPosition();
          return (
            <div 
              key={number} 
              style={{
                fontSize: 38, 
                maxHeight: 35,
                animationDelay: isShuffling ? `${Math.random() * 0.5}s` : '0s',
                animationDuration: isShuffling ? `${1.5 + Math.random() * 0.5}s` : '0s',
                '--random-x1': `${pos1.x}px`,
                '--random-y1': `${pos1.y}px`,
                '--random-x2': `${pos2.x}px`,
                '--random-y2': `${pos2.y}px`
              }} 
              className={`col m-1 p-0 ${isCalled ? 'called' : ''} ${isShuffling ? 'animate-swap' : ''}`}
            >
              <span className={isShuffling ? 'animate-inner-rotate inline-block' : ''}>
                {number}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const generateRows2 = (letter, start) => {
    const getRandomPosition = () => {
      const x = Math.random() * 100 - 50;
      const y = Math.random() * 100 - 50;
      return { x, y };
    };

    return (
      <div className="row p-0" style={{maxHeight: 60}}>
        <div 
          className={`col bg-gray-800 text-primary text-center m-1 pb-1 px-0 ${isShuffling ? 'animate-shuffle' : ''}`}
          style={{fontSize: 38, maxHeight: 48, maxWidth: 45}}
        >
          <span className={isShuffling ? 'animate-inner-rotate inline-block' : ''}>
            {letter}
          </span>
        </div>
        {[...Array(15)].map((_, i) => {
          const number = start + i;
          const isCalled = calledNumbersArray.includes(letter + number);
          const pos1 = getRandomPosition();
          const pos2 = getRandomPosition();
          return (
            <div 
              key={number} 
              className={`h-12 w-12 flex items-center justify-center
                text-2xl font-semibold rounded-lg
                transition-all duration-300 ease-in-out col m-1 p-0 
                ${isCalled ? 'bg-blue-600 text-gray-300 shadow-lg shadow-blue-500/20' : 'bg-gray-700 text-gray-300'}
                ${isShuffling ? 'animate-swap' : ''}
              `}
              style={{
                animationDelay: isShuffling ? `${Math.random() * 0.5}s` : '0s',
                animationDuration: isShuffling ? `${1.5 + Math.random() * 0.5}s` : '0s',
                '--random-x1': `${pos1.x}px`,
                '--random-y1': `${pos1.y}px`,
                '--random-x2': `${pos2.x}px`,
                '--random-y2': `${pos2.y}px`
              }}
            >
              <span className={isShuffling ? 'animate-inner-rotate inline-block' : ''}>
                {number}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const generateRows3 = (letter, start) => {
    // Generate random positions for each number
    const getRandomPosition = () => {
      const x = Math.random() * 100 - 50; // Random value between -50 and 50
      const y = Math.random() * 100 - 50;
      return { x, y };
    };

    return (
      <div className="space-y-2 flex">
        <div 
          className={`
            w-12 h-12 flex items-center justify-center
            text-2xl font-bold text-center rounded-lg text-white shadow-lg p-4
            ${isShuffling ? 'animate-shuffle' : ''}
            ${letter === 'B' ? 'bg-gradient-to-r from-red-400 to-red-600' : ''}
            ${letter === 'I' ? 'bg-gradient-to-r from-blue-400 to-blue-600' : ''}
            ${letter === 'N' ? 'bg-gradient-to-r from-green-400 to-green-600' : ''}
            ${letter === 'G' ? 'bg-gradient-to-r from-amber-400 to-amber-600' : ''}
            ${letter === 'O' ? 'bg-gradient-to-r from-purple-400 to-purple-600' : ''}
          `}
          style={{
            animationDelay: isShuffling ? `${Math.random() * 0.3}s` : '0s'
          }}
        >
          <span className={isShuffling ? 'animate-inner-rotate inline-block' : ''}>
            {letter}
          </span>
        </div>
  
        <div className="flex flex-row space-x-2 mt-0">
          {[...Array(15)].map((_, index) => {
            const number = start + index;
            const isCalled = calledNumbersArray.includes(letter + number);
            const pos1 = getRandomPosition();
            const pos2 = getRandomPosition();
            
            return (
              <div
                key={index}
                className={`
                  h-8 w-8 flex items-center justify-center rounded-lg
                  text-lg font-semibold transition-all duration-300 ml-1
                  ${isShuffling ? 'animate-swap' : ''}
                  ${isCalled 
                    ? `
                      bg-gradient-to-r shadow-lg p-4
                      ${letter === 'B' ? 'from-red-400 to-red-600' : ''}
                      ${letter === 'I' ? 'from-blue-400 to-blue-600' : ''}
                      ${letter === 'N' ? 'from-green-400 to-green-600' : ''}
                      ${letter === 'G' ? 'from-amber-400 to-amber-600' : ''}
                      ${letter === 'O' ? 'from-purple-400 to-purple-600' : ''}
                      text-white
                    `
                    : 'p-4 bg-white/5 text-white/80 backdrop-blur-sm border border-white/10'}
                  transform hover:scale-105
                `}
                style={{
                  animationDelay: isShuffling ? `${Math.random() * 0.5}s` : '0s',
                  animationDuration: isShuffling ? `${1.5 + Math.random() * 0.5}s` : '0s',
                  '--random-x1': `${pos1.x}px`,
                  '--random-y1': `${pos1.y}px`,
                  '--random-x2': `${pos2.x}px`,
                  '--random-y2': `${pos2.y}px`
                }}
              >
                <span className={isShuffling ? 'animate-inner-rotate inline-block' : ''}>
                  {number}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const pauseGame = async () => {
    setIsPaused(true);
  }
  
  const resumeGame = async () => {
    setIsPaused(false);
  }

  const endGame = async () => {
    try {  
      const response = await api.post(`${API}/game/${gameId}/end`);

      if (gameType === 'multiplierBingo') {
        navigate('/multiplier');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error ending the game:', error);
    }
  };
  
  const winningPatterns = {
    rows: [
      [1, 2, 3, 4, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 6, 7, 8, 9, 10, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 11, 12, 13, 14, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16, 17, 18, 19, 20, 0, 0, 0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    columns: [
      [1, 0, 0, 0, 0, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 0, 0, 0, 0],
      [0, 2, 0, 0, 0, 0, 7, 0, 0, 0, 0, 12, 0, 0, 0, 0, 17, 0, 0, 0, 0, 22, 0, 0, 0],
      [0, 0, 3, 0, 0, 0, 0, 8, 0, 0, 0, 0, 13, 0, 0, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0],
      [0, 0, 0, 4, 0, 0, 0, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 19, 0, 0, 0, 0, 24, 0],
      [0, 0, 0, 0, 5, 0, 0, 0, 0, 10, 0, 0, 0, 0, 15, 0, 0, 0, 0, 20, 0, 0, 0, 0, 25]
    ],
    diagonals: [
      [1, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 25],
      [0, 0, 0, 0, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 0, 0, 0, 0]
    ],
    corners: [
      [1, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 25]
    ],
    surroundingFree: [
      [0, 0, 0, 0, 0, 0, 7, 0, 9, 0, 0, 0, 0, 0, 0, 0, 16, 0, 18, 0, 0, 0, 0, 0, 0]
    ],
    fullCard: [
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25]
    ],
    lShape: [
      [1, 0, 0, 0, 0, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    bothDiagonals: [
      [1, 0, 0, 0, 5, 0, 7, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 19, 0, 21, 0, 0, 0, 25]
    ],
    tShape: [
      [1, 2, 3, 4, 5, 0, 0, 8, 0, 0, 0, 0, 13, 0, 0, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0]
    ],
    sevenShape: [
      [1, 2, 3, 4, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 0, 0, 0, 0]
    ],
    innerSquare: [
      [0, 0, 0, 0, 0, 0, 7, 8, 9, 0, 0, 11, 12, 13, 0, 0, 16, 17, 18, 0, 0, 0, 0, 0, 0]
    ],
    diamond: [
      [0, 0, 3, 0, 0, 0, 7, 0, 9, 0, 11, 0, 13, 0, 15, 0, 17, 0, 19, 0, 0, 0, 23, 0, 0]
    ],
    cPattern: [
      [1, 2, 3, 4, 5, 6, 0, 0, 0, 0, 11, 0, 0, 0, 0, 16, 0, 0, 0, 0, 21, 22, 23, 24, 25]
    ],
    numberFour: [
      [1, 0, 0, 0, 5, 6, 0, 0, 0, 10, 11, 12, 13, 14, 15, 0, 0, 0, 0, 20, 0, 0, 0, 0, 25]
    ],
    hShape: [
      [1, 0, 0, 0, 5, 6, 0, 0, 0, 10, 11, 12, 13, 14, 15, 16, 0, 0, 0, 20, 21, 0, 0, 0, 25]
    ],
    cross: [
      [0, 0, 3, 0, 0, 0, 0, 8, 0, 0, 11, 12, 13, 14, 15, 0, 0, 18, 0, 0, 0, 0, 23, 0, 0]
    ],
    outerSquare: [
      [1, 2, 3, 4, 5, 6, 0, 0, 0, 10, 11, 0, 0, 0, 15, 16, 0, 0, 0, 20, 21, 22, 23, 24, 25]
    ],
    zPattern: [
      [1, 2, 3, 4, 5, 0, 0, 0, 9, 0, 0, 0, 13, 0, 0, 0, 17, 0, 0, 0, 21, 22, 23, 24, 25]
    ]
  };

  useEffect(() => {
    const selectedPatternTypes = Array.isArray(winningPattern) ? winningPattern : JSON.parse(localStorage.getItem('winningPattern') || '["any"]');
    let patternsToShow = [];
    
    if (selectedPatternTypes.includes('any')) {
      const commonPatterns = ['rows', 'columns', 'diagonals', 'surroundingFree', 'corners'];
      patternsToShow = commonPatterns.map(key => winningPatterns[key][0]);
    } else {
      selectedPatternTypes.forEach(patternType => {
        if (winningPatterns[patternType]) {
          patternsToShow = [...patternsToShow, ...winningPatterns[patternType]];
        }
      });
    }
    
    if (patternsToShow.length === 0) {
      patternsToShow = [winningPatterns.rows[0]];
    }
    
    const tables = patternsToShow.map((pattern) => generateTable(pattern));
    setSlideshowTables(tables);
  }, [winningPattern]);
    
    
  const generateTable = (pattern) => {
    const cellSize = 25;
    const dotSize = 25;
  
    const cells = pattern.map((value, index) => (
      <td
        style={{
          padding: '15px 19px',
          position: 'relative',
          width: `25px`,
          height: `26px`,
          backgroundColor: '#E2E8F0',
          border: '1px solid black',
        }}
      >
        <div
          key={index}
          className='text-center mx-auto'
          style={{
            width: `${dotSize}px`,
            height: `${dotSize}px`,
            backgroundColor: value === 12 ? 'yellow' : value > 0 ? 'blue' : 'transparent',
            borderRadius: '50%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        ></div>
      </td>
    ));
  
    const rows = [];
    for (let i = 0; i < 5; i++) {
      rows.push(
        <tr key={i} >
          {cells.slice(i * 5, (i + 1) * 5)}
        </tr>
      );
    }
  
    const headerCells = ['B', 'I', 'N', 'G', 'O'].map((letter, index) => (
      <th
        key={index}
        className='fw-bold text-center'
        style={{
          backgroundColor: ['#3B82F6', '#EF4444', '#F97316', '#22C55E', '#ffc900'][index],
          width: `10px`,
          height: `10px`,
          fontSize: '50',
          border: '1px solid white',
        }}
      >
        {letter}
      </th>
    ));
  
    return (
      <table className='mb-0 pb-0' style={{backgroundColor: '#E2E8F0'}}>
        <thead>
          <tr>{headerCells}</tr>
        </thead>
        <tbody className='mb-0 pb-0' style={{backgroundColor: '#E2E8F0'}}>{rows}</tbody>
      </table>
    );
  };
  
  const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      cssEase: 'linear',
      arrows: false,
  };

  const handleCloseWinnerModal = () => {
        setShowWinnerModal(false);
        setShowCardDisplay(false);
        setShowConfetti(false);
        setCheckedCards([]);
        setCheckedResults([]);
        setNumberOfWinners(0);
  };
  
  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderV2Layout = () => {
    return (
      <div className="bg-gray-900 min-h-screen text-white p-4">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-3">
            <div className="bg-gray-800 rounded-lg p-6 shadow-lg">
              <div className='flex space-x-2'> 
                <FaCrown size={32} className="icon"/> 
                <div className="phoenix-text">FAST 
                  <span className="bingo-text ml-2">BINGO</span>
                </div>
              </div>
              <div className="space-y-4">
                <div>
                  <h3 className="text-xl mb-2">Total Calls</h3>
                  <div className="bg-gray-700 p-4 rounded-lg text-center">
                    <span className="text-4xl font-bold text-blue-400">
                      {calledNumbersArray.length}
                    </span>
                  </div>
                </div>

                <div>
                  <h3 className="text-xl mb-2">Next Call In</h3>
                  <div className="bg-gray-700 p-4 rounded-lg text-center">
                    <span className="text-6xl font-bold text-green-400">
                      {countdown}
                    </span>
                  </div>
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={handleShuffle}
                    disabled={!isPaused || isShuffling}
                    className={`w-1/2 py-3 px-6 bg-gradient-to-r from-purple-400 to-pink-500 hover:from-purple-500 hover:to-pink-600 rounded-xl text-white font-medium transform transition-all hover:scale-105 shadow-lg disabled:opacity-50 ${isShuffling ? 'animate-pulse' : ''}`}
                  >
                    {isShuffling ? 'Shuffling...' : 'Shuffle'}
                  </button>
                  {isPaused ? (
                    <button
                      onClick={resumeGame}
                      className="w-full py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
                    >
                      Resume
                    </button>
                  ) : (
                    <button
                      onClick={pauseGame}
                      className="w-full py-2 bg-yellow-600 hover:bg-yellow-700 rounded-lg transition-colors"
                    >
                      Pause
                    </button>
                  )}
                </div>

                <div className="flex gap-2">
                  <input
                    type="text"
                    value={checkedNumber}
                    onChange={(e) => setCheckedNumber(e.target.value)}
                    placeholder="Card number"
                    className="w-75 bg-gray-700 border border-gray-600 rounded-lg px-3 py-2"
                  />
                  <button
                    onClick={handleCheckNumber}
                    disabled={isChecking || !isPaused}
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg disabled:opacity-50"
                  >
                    Check
                  </button>
                </div>

                <button
                  onClick={endGame}
                  className="w-full py-2 bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
                >
                  End Game
                </button>
              </div>
            </div>
          </div>

          <div className="col-span-9">
            <div className="">
                  <div className="rounded-lg p-2 shadow-lg d-flex justify-content-between">
                    <h3 className="text-xl mb-2">Last Called Numbers</h3>
                    <div className="text-2xl text-right space-x-2">
                      <span className="text-white text-4xl">ደራሽ</span>
                      {gameType === 'multiplierBingo' ? (
                        <span className="text-green-500 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {multiplier}x
                        </span>
                      ) : gameType !== 'free' && payoutAmount === (JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate) ? (
                        <span className="text-green-500 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {payoutAmount} Birr
                        </span>
                      ) : gameType === 'free' ? (
                        <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {(payoutAmount * (1 - commissionRate)).toFixed(0)} + {(payoutAmount * commissionRate).toFixed(0)} ብር ቦነስ
                        </span>
                      ) : (
                        <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {((JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate))} + 
                          {(payoutAmount - ((JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate))).toFixed(0)} Birr bonus
                        </span>
                      )}
                    </div>
                  </div>  
                  <div className="flex items-center justify-center gap-4">
                    {calledNumbersArray.slice(-6).reverse().map((number, index) => {
                      const getBgColor = (num) => {
                        if (num.startsWith('B')) return 'bg-blue-600';
                        if (num.startsWith('I')) return 'bg-red-600';
                        if (num.startsWith('N')) return 'bg-orange-500';
                        if (num.startsWith('G')) return 'bg-green-600';
                        if (num.startsWith('O')) return 'bg-yellow-500';
                        return 'bg-gray-700';
                      };
                  
                      return (
                      <div
                        key={index}
                        className={`
                          flex items-center justify-center rounded-full
                          ${number === calledNumbersArray[calledNumbersArray.length - 1]
                            ? `w-48 h-48 ${getBgColor(number)} text-7xl fw-bold animate-pulse` 
                            : `w-32 h-32 ${getBgColor(number)} text-5xl fw-bold`}
                        `}
                      >
                        {number}
                      </div>
                      )
                    })}
                  </div>
              </div>
              <div className="bg-gray-800 rounded-lg px-3 py-2 shadow-lg mt-2">
                <div className="grid grid-cols-1 gap-1 mb-3">
                  {generateRows2('B', 1)}
                  {generateRows2('I', 16)}
                  {generateRows2('N', 31)}
                  {generateRows2('G', 46)}
                  {generateRows2('O', 61)}
                </div>
                <audio ref={audioRef} />
              </div>
            </div>
        </div>
      </div>
    );
  };

  const renderGameControls = () => {
    return (
      <div className="bg-white/10 rounded-2xl p-2 mx-auto border border-white/20 shadow-xl space-y-4">
        <div className="flex justify-center gap-2">
          {isPaused ? (
            <button
              onClick={resumeGame}
              className="w-1/2 py-3 px-6 bg-gradient-to-r from-green-400 to-emerald-500 hover:from-green-500 hover:to-emerald-600 rounded-xl text-white font-medium transform transition-all hover:scale-105 shadow-lg"
            >
              Resume
            </button>
          ) : (
            <button
              onClick={pauseGame}
              className="w-1/2 py-3 px-6 bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 rounded-xl text-white font-medium transform transition-all hover:scale-105 shadow-lg"
            >
              Pause
            </button>
          )}
          <button
            onClick={handleShuffle}
            disabled={!isPaused || isShuffling}
            className={`w-1/2 py-3 px-6 bg-gradient-to-r from-purple-400 to-pink-500 hover:from-purple-500 hover:to-pink-600 rounded-xl text-white font-medium transform transition-all hover:scale-105 shadow-lg disabled:opacity-50 ${isShuffling ? 'animate-pulse' : ''}`}
          >
            {isShuffling ? 'Shuffling...' : 'Shuffle'}
          </button>
        </div>
        
        <div className="flex gap-2">
          <input
            type="text"
            value={checkedNumber}
            onChange={(e) => setCheckedNumber(e.target.value)}
            placeholder="Card number"
            className="flex-1 w-50 px-2 py-1 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/50 focus:ring-2 focus:ring-purple-500 focus:border-transparent backdrop-blur-sm"
          />
          <button
            onClick={handleCheckNumber}
            disabled={isChecking}
            className="px-2 py-1 bg-gradient-to-r from-purple-400 to-pink-500 hover:from-purple-500 hover:to-pink-600 rounded-xl text-white font-medium transform transition-all hover:scale-105 disabled:opacity-50 shadow-lg"
          >
            Check
          </button>
        </div>
        
        <button
          onClick={endGame}
          className="w-full py-3 bg-gradient-to-r from-red-400 to-rose-500 hover:from-red-500 hover:to-rose-600 rounded-xl text-white font-medium transform transition-all hover:scale-105 shadow-lg"
        >
          End Game
        </button>
      </div>
    );
  };

  useEffect(() => {
    if (location.state) {
      if (location.state.isJackpotGame) {
        setIsJackpotGame(true);
        setJackpotPool(location.state.jackpotPool || 0);
      }
    }
  }, [location]);

  return (
    <div className="container-fluid bg-dark p-1" style={{ minHeight: '100vh' }}>
      <style>{shuffleAnimationStyles}</style>
      {!audioFilesLoaded && (
        <div className="loading-overlay">
          <div className="loading-content">
            <div className="progress-bar">
              <div 
                className="progress-fill"
                style={{ width: `${loadingProgress}%` }}
              ></div>
            </div>
            <p>Loading Audio Files: {loadingProgress}%</p>
          </div>
        </div>
      )}
      <audio ref={winAudioRef} src={winSound} />
      <audio ref={loseAudioRef} src={loseSound} />
      <GameVersionToggle />

      {showConfetti && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
          pointerEvents: 'none'
        }}>
          <Confetti
            width={windowDimensions.width}
            height={windowDimensions.height}
            recycle={false}
            numberOfPieces={200}
            gravity={0.1}
          />
        </div>
      )}

      <Modal show={showHouseWinModal} onHide={handleCloseHouseWinModal} size="xl">
        <Modal.Header closeButton className="bg-dark text-white">
          <Modal.Title className='text-center'>Online Player Win!</Modal.Title>
        </Modal.Header>
        <Modal.Body className='bg-dark text-white'>
          {houseWinningCard && (
            <BingoCard
              cardNumber={houseWinningCard}
              calledNumbers={calledNumbersArray}
              isWinner={true}
              winningNumbers={winningNumbers}
              fetchCardDetails={() => fetchWinningCardDetails(houseWinningCard)}
            />
          )}
        </Modal.Body>
        <Modal.Footer className='bg-dark'>
          <button className="btn btn-secondary" onClick={handleCloseHouseWinModal}>
            Close and Return to Dashboard
          </button>
        </Modal.Footer>
      </Modal>

      <Dialog open={showWinnerModal} onOpenChange={handleCloseWinnerModal}>
        <DialogContent className="sm:max-w-[100vw] sm:h-[100vh] bg-gray-100/10 backdrop-blur-sm text-white rounded-none">          
          {showCardDisplay && (
            <div className="">
              <div className={` grid ${
                checkedCards.length === 1 
                  ? 'grid-cols-1 justify-center' 
                  : checkedCards.length === 2 ? 'grid-cols-2' : checkedCards.length === 3 ? 'grid-cols-3' : 'grid-cols-4'
                } gap-0`}>
                {checkedCards.map((cardNumber, index) => (
                  <div key={index} className={`ml-2 ${
                    checkedCards.length === 1 ? '' : ''
                  }`}>
                    <BingoCard 
                      cardNumber={cardNumber}
                      calledNumbers={calledNumbersArray} 
                      isWinner={checkedResults[index]}
                      winningNumbers={winningNumbers}
                      fetchCardDetails={() => fetchWinningCardDetails(cardNumber)}
                      className="w-full"
                    />
                    {checkedResults[index] && payoutToWinner && (
                      <h3 className="mb-0 text-center text-4xl font-bold text-green-400 pul">
                          { numberOfWinners !== 0 ? (payoutToWinner / numberOfWinners).toFixed(0) : payoutToWinner} ብር አሸናፊ
                        </h3>
                    )}
                    {checkedResults[index] && gameType === 'multiplierBingo' && winningAmount && (
                      <div className="mt-4 text-center">
                        <h3 className="text-2xl font-bold text-green-400">
                          Winning Amount: {winningAmount} Birr
                        </h3>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              
              <div className="flex justify-center gap-4 mt-5">
                <input
                  type="text"
                  value={checkedNumber}
                  onChange={(e) => setCheckedNumber(e.target.value)}
                  placeholder="ሌላ ካርቴላ ቁጥር ያስገቡ"
                  className="px-3 py-2 bg-gray-800 rounded-md text-white"
                />
                <Button 
                  onClick={handleCheckNumber} 
                  disabled={isChecking}
                  className="bg-warning"
                >
                  Check
                </Button>
                <Button 
                  onClick={handleLockCard}
                  className="bg-info"
                >
                  Lock Card
                </Button>
                <Button className="bg-danger" onClick={handleCloseWinnerModal}>
                  Close
                </Button>
              </div>
            </div>
          )}
          
          <DialogFooter className="mt-6">         
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {gameVersion === 'v1' ? (
        <div className="row">
          <div className="col-2 text-white">
            <h3 className="text-center" style={{fontSize: '1.75rem', fontWeight: 700}}>Total Calls</h3>
            <h1 className="call_number x-5 mx-4" style={{backgroundColor: '#000', fontSize: '4rem'}}>{calledNumbersArray.length}</h1>
            <div className="card mx-1">
              <div className="card-body p-0">
                <Slider {...settings}>
                  {slideshowTables.map((table, index) => (
                    <div key={index}>{table}</div>
                  ))}
                </Slider>
              </div>
            </div>
            <div>
              <h5 className="mt-1 mb-0 text-center">Next Number</h5>
              <h2 className="text-center my-0" style={{fontSize: '4rem'}}>{countdown}</h2>
            </div>
            <div className='mx-auto text-center my-1 flex flex-row gap-2'>
                <button
                onClick={handleShuffle}
                disabled={!isPaused || isShuffling}
                className={`w-1/2 py-3 px-6 bg-gradient-to-r from-purple-400 to-pink-500 hover:from-purple-500 hover:to-pink-600 rounded-xl text-white font-medium transform transition-all hover:scale-105 shadow-lg disabled:opacity-50 ${isShuffling ? 'animate-pulse' : ''}`}
                >
                  {isShuffling ? 'Shuffling...' : 'Shuffle'}
                </button>
              {
                isPaused ? (
                  <button className="btn btn-primary text-center fs-5 px-4 py-1 mx-auto text-center" onClick={resumeGame}>Resume</button>  
                ) : (
                  <button className="btn btn-warning text-center" onClick={pauseGame}>Pause</button>
                )
              }
            </div>
            <div className="d-flex flex-row mx-2">
              <input
                type="text"
                value={checkedNumber}
                onChange={(e) => setCheckedNumber(e.target.value)}
                placeholder="Card number"
                style={{backgroundColor: '#475569', marginRight: '5px', width:'50%'}}
              />
              <button className="btn btn-warning my-0" onClick={handleCheckNumber} disabled={isChecking || !isPaused}>
                Check
              </button>
            </div>
            <div className='mx-auto text-center'>
              <button className="btn btn-danger text-center mt-1 ml-2" onClick={endGame}>
                End game
              </button>
            </div>
            
          </div>
          <div className="col-10 mt-1 p-0 text-secondary fs-3 fw-bold" style={{maxHeight: 40}}>
            <div style={{backgroundColor: '#222'}}>
              {generateRows('B', 1)}
              {generateRows('I', 16)}
              {generateRows('N', 31)}
              {generateRows('G', 46)}
              {generateRows('O', 61)}
            </div>
            <div className="payout-amount align-right fs-1 text-white text-end mt-1 mx-5">
              ደራሽ
              {isJackpotGame ? (
                <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl animate-pulse">
                  JACKPOT: {payoutAmount.toLocaleString()} Birr
                </span>
              ): gameType === 'multiplierBingo' ? (
                <span className="text-green-500 bg-gray-900 px-2 py-1 rounded text-5xl">
                  {multiplier}x
                </span>
              ) : gameType !== 'free' && payoutAmount === (JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate) ? (
                <span className="text-green-500 bg-gray-900 px-2 py-1 rounded text-5xl">
                  {payoutAmount} Birr
                </span>
              ) : gameType === 'free' ? (
                <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl">
                  {(payoutAmount * (1 - commissionRate)).toFixed(0)} + {(payoutAmount * commissionRate).toFixed(0)} ብር ቦነስ
                </span>
              ) : payoutAmount < (JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate) ? (
                <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl">
                  {payoutAmount} Birr
                </span>
              ) : (
                <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl">
                  {((JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate))} + 
                  {(payoutAmount - ((JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate))).toFixed(0)} Birr bonus
                </span>
              )}
            </div>
            <div className="last-called-number-container mt-0 " style={{backgroundColor: '#222'}}>
              {calledNumbersArray.slice(-6).map((number, index) => (
                <div key={index} className={`${number.includes('B') ? 'border-b' : number.includes('I') ? 'border-i' : number.includes('N') ? 'border-n' : number.includes('G') ? 'border-g' : 'border-o'} ${number === calledNumbersArray[calledNumbersArray.length - 1] ? 'last-called-number-circle' : 'last-five-numbers'}`} style={{ margin: '5px 5px' }}>
                  {number}
                </div>
              ))}
              <audio ref={audioRef} />
            </div>
          </div>
        </div>
      ): gameVersion === 'v2' ? renderV2Layout() : gameVersion === 'v3'? 
        (
          <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 p-3 relative overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob top-0 left-0"></div>
            <div className="absolute w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000 top-0 right-0"></div>
            <div className="absolute w-96 h-96 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000 bottom-0 left-1/2"></div>
          </div>
  
          <div className="mx-auto relative z-10">
            <div className="grid grid-cols-12 gap-3">
              {/* Left Column - Game Controls */}
              <div className="col-span-3 space-y-2">
                <div className="backdrop-blur-lg bg-white/10 rounded-2xl card-body p-0">
                  <Slider {...settings}>
                    {slideshowTables.map((table, index) => (
                      <div key={index}>{table}</div>
                    ))}
                  </Slider>
                </div>
                {/* Total Calls Card */}
                <div className="backdrop-blur-lg bg-white/10 rounded-2xl p-2 border border-white/20 shadow-xl">
                  <div className="text-center">
                    <h3 className="text-white/80 text-sm font-medium mb-1">Total Calls</h3>
                    <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
                      {calledNumbersArray.length}
                    </div>
                  </div>
                </div>
  
                {/* Timer Card */}
                <div className="backdrop-blur-lg bg-white/10 rounded-2xl p-2 border border-white/20 shadow-xl">
                  <div className="text-center">
                    <h3 className="text-white/80 text-sm font-medium mb-1">Next Call In</h3>
                    <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                      {countdown}
                    </div>
                  </div>
                </div>
  
                {/* Game Controls */}
                {renderGameControls()}
              </div>
  
              {/* Right Column - Game Board */}
              <div className="col-span-9">
                <div className="space-y-4">
                  {generateRows3('B', 1)}
                  {generateRows3('I', 16)}
                  {generateRows3('N', 31)}
                  {generateRows3('G', 46)}
                  {generateRows3('O', 61)}
                </div>
                <div className="mt-2">
                  <div className="payout-amount align-right fs-1 text-white text-end mt-1 mx-5">
                    ደራሽ 
                    {isJackpotGame ? (
                        <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl animate-pulse">
                          JACKPOT: {payoutAmount.toLocaleString()} Birr
                        </span>
                    ) : gameType === 'multiplierBingo' ? (
                        <span className="text-green-500 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {multiplier}x
                        </span>
                      ) : gameType !== 'free' && payoutAmount === (JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate) ? (
                        <span className="text-green-500 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {payoutAmount} Birr
                        </span>
                      ) : gameType === 'free' ? (
                        <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {(payoutAmount * (1 - commissionRate)).toFixed(0)} + {(payoutAmount * commissionRate).toFixed(0)} ብር ቦነስ
                        </span>
                      ) : (
                        <span className="text-yellow-400 bg-gray-900 px-2 py-1 rounded text-5xl">
                          {((JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate))} + 
                          {(payoutAmount - ((JSON.parse(localStorage.getItem('bettingAmount')) * JSON.parse(localStorage.getItem('selectedNumbers')).length) * (1 - commissionRate))).toFixed(0)} Birr bonus
                        </span>
                      )}
                  </div>
                <div className="flex items-center justify-center gap-6">
                  {calledNumbersArray.slice(-5).reverse().map((number, index) => {
                    const letter = number.charAt(0);
                    const colorClass = 
                      letter === 'B' ? 'from-red-400 to-red-600' :
                      letter === 'I' ? 'from-blue-400 to-blue-600' :
                      letter === 'N' ? 'from-green-400 to-green-600' :
                      letter === 'G' ? 'from-amber-400 to-amber-600' :
                                    'from-purple-400 to-purple-600';
  
                    return (
                      <div
                        key={index}
                        className={`
                          flex items-center justify-center rounded-full
                          bg-gradient-to-r ${colorClass}
                          shadow-lg border border-white/20
                          ${index === 0 
                            ? 'w-48 h-48 text-4xl animate-pulse' 
                            : 'w-32 h-32 text-xl opacity-80'}
                          text-white transform transition-all hover:scale-105
                        `}
                      >
                        {number}
                      </div>
                    );
                  })}
                </div>
              </div>
              </div>
            </div>
          </div>
          <audio ref={audioRef} />
        </div>
        ): (
        <div></div>
      )}
      
      {/* {!audioFilesLoaded && <LoadingOverlay />} */}
      <Toaster position="top-center" reverseOrder={false} />
    </div>
  );
};

export default GamePage;
